// @ts-nocheck
export const MARKET_SOURCES = ['TRANS', 'TIMOCOM', 'TELEROUTE', 'ECONTAINERS', 'SHIPPERS']

export const buildDefaultMarketStatus = () => ({
  lastSyncAt: null,
  sources: Object.fromEntries(MARKET_SOURCES.map((source) => [source, { status: 'offline' }])),
})

